import { depthPowerTrees } from "../../../workers/Cascade/tree_v2/assignDepth.worker";
import { connectPowerTreePaths } from "../../../workers/Cascade/tree_v2/connect.worker";
import { mergePowerTrees } from "../../../workers/Cascade/tree_v2/merge.worker";
import { setNewPowerTreesValue } from "../../../workers/Cascade/tree_v2/setValue.worker"
import { sortPowerTreePaths } from "../../../workers/Cascade/tree_v2/sort.work";
import { transformPowerTrees } from "../../../workers/Cascade/tree_v2/transform.worker";

async function initPowerTreeWorker(rawPowerTrees, prevPowerTrees, connectors, showGnd) {
  const valuePowerTrees = await setNewPowerTreesValue(rawPowerTrees, prevPowerTrees);
  const pathPowerTrees = await connectPowerTreePaths(valuePowerTrees, connectors, showGnd);
  const sortPowerTrees = await sortPowerTreePaths(pathPowerTrees);
  const transPowerTrees = await transformPowerTrees(sortPowerTrees);
  const mergedPowerTrees = await mergePowerTrees(transPowerTrees);
  const deepPowerTrees = await depthPowerTrees(mergedPowerTrees);
  return deepPowerTrees
}

async function refreshPowerTreeWorker(rawPowerTrees, connectors, showGnd) {
  const pathPowerTrees = await connectPowerTreePaths(rawPowerTrees, connectors, showGnd);
  const sortPowerTrees = await sortPowerTreePaths(pathPowerTrees);
  const transPowerTrees = await transformPowerTrees(sortPowerTrees);
  const mergedPowerTrees = await mergePowerTrees(transPowerTrees);
  const deepPowerTrees = await depthPowerTrees(mergedPowerTrees);
  return deepPowerTrees
}

export {
  initPowerTreeWorker,
  refreshPowerTreeWorker
}